module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "index"
    }
  }, [_c('Headers'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('Footers'), _vm._v(" "), _c('div', {
    staticClass: "to-top",
    on: {
      "click": _vm.backTop
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/back_to_top.png"),
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c79be7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 511
// module chunks = 2